import { memo, useMemo } from 'react';
import { Marker } from '@adamscybot/react-leaflet-component-marker';
import { MapPointIcon } from '@icons';
import { HubMarkerType } from '@lp/features/RoutePlanner/types';
import { getIconMapColor } from '@lp/features/RoutePlanner/utils';
import { SegmentTypeEnum } from '@/api/apis/route';
import { HubDevicesTooltip } from './HubDevicesTooltip';
import { HubCSTooltip } from './HubCSTooltip';

export const HubMarker = memo(
  ({
    code,
    name,
    location,
    devices,
    clinicalSpecialists,
    showTooltip = true,
  }: HubMarkerType & { showTooltip?: boolean }) => {
    const color = getIconMapColor(SegmentTypeEnum.hub);

    const icon = useMemo(
      () => (
        <div className="relative flex flex-col justify-center items-center -translate-y-1/3">
          <div className="relative text-base-25 mt-0.5 overflow-hidden" style={{ color }}>
            <MapPointIcon />
            <span className="w-full font-secondary text-center absolute top-1 text-base-90 text-s-sb">
              {code.substring(0, 3)}
            </span>
          </div>
          <div className="box-border w-3 h-3 rounded-full border-3 bg-white" style={{ borderColor: color }} />
          {showTooltip && (
            <>
              {!!devices?.length && <HubDevicesTooltip list={devices} title={name} />}
              {!!clinicalSpecialists?.length && <HubCSTooltip list={clinicalSpecialists} title={name} />}
            </>
          )}
        </div>
      ),
      [code, color, name, devices, clinicalSpecialists, showTooltip],
    );

    return (
      <Marker
        position={location}
        zIndexOffset={10}
        componentIconOpts={{
          disableClickPropagation: true,
        }}
        icon={icon}
      />
    );
  },
);
